module.exports = __webpack_public_path__ + "img/龙眼肉.d215c3e3.jpg";